import Unauthorized from "@/../assets/images/401.svg";
import E404 from "@/../assets/images/404.svg";
import CommonButton from "@/components/utils/CommonButton";
import { Colors } from "@/enums/Colors";
import { LazoPaths } from "@/enums/LazoPaths";
import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { getNavCount } from "@/hooks/useNavigationCount";
import { PostLoginRedirectStorageKey } from "@/utils/RedirectUtils";
import { Box, Typography } from "@mui/material";
import { useTransition } from "react";
import { useNavigate } from "react-router-dom";

interface UnauthorizedScreenProps {
  isNotFound?: boolean;
}

function UnauthorizedScreen({ isNotFound }: UnauthorizedScreenProps) {
  const [isPending, startTransition] = useTransition();
  const navigate = useNavigate();
  const loggedIn = AuthService.isLogged();

  function onClick() {
    startTransition(() => {
      const navCount = getNavCount();
      if (loggedIn && navCount > 0) {
        navigate(-1);
      } else if (loggedIn) {
        navigate(LazoPaths.TASKS);
      } else {
        sessionStorage.setItem(PostLoginRedirectStorageKey, location.href);
        navigate(LazoPaths.LOGIN);
      }
    });
  }

  const title = isNotFound ? "Page Not Found" : !loggedIn ? "Session Required" : "Access Restricted";
  const body = isNotFound
    ? "The page you're looking for doesn't exist or has been moved."
    : !loggedIn
      ? "Please log in to continue."
      : "You don't have permission to view this page.";

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "2rem",
        padding: "2rem",
      }}
    >
      <img src={isNotFound ? E404.src : Unauthorized.src} style={{ maxWidth: "260px", width: "100%" }} />

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem", maxWidth: "360px" }}>
        <Typography sx={{ fontSize: "1.375rem", fontWeight: 600, color: Colors.BLACK_151517, textAlign: "center" }}>{title}</Typography>
        <Typography sx={{ fontSize: "1rem", fontWeight: 400, color: Colors.DARKER_GRAY, textAlign: "center", lineHeight: 1.6 }}>
          {body}
        </Typography>
      </Box>

      <CommonButton sx={{ px: "2rem", height: "2.75rem" }} onClick={onClick} disabled={isPending}>
        <Typography>{!loggedIn ? "Log In" : "Go Back"}</Typography>
      </CommonButton>
    </Box>
  );
}

export default UnauthorizedScreen;
